import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./properties-search-sectional-title.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./properties-search-sectional-title.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../../shared/models/alert";
import { PropertiesConstants } from "../../properties.constants";
import { PropertySearchService } from "../../shared/services/property-search.service";
let PropertiesSearchSectionalTitleComponent = class PropertiesSearchSectionalTitleComponent {
    propertySearchService;
    appController;
    changeDetectorRef;
    advancedSearchOccurred = new EventEmitter();
    propertiesSectionalTitleLabel = PropertiesConstants.FORM_CONTROLS.propertiesSectionalTitleLabel;
    propertiesSectionalTitleFormControl = PropertiesConstants.FORM_CONTROLS.propertiesSectionalTitleControl;
    propertiesUnitNumberLabel = PropertiesConstants.FORM_CONTROLS.propertiesUnitNumberLabel;
    propertiesUnitNumberFormControl = PropertiesConstants.FORM_CONTROLS.propertiesUnitNumberControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = PropertiesConstants.FORM_CONTROLS.searchText;
    propertiesSectionalTitleForm;
    propertySearchCallback;
    constructor(propertySearchService, appController, changeDetectorRef) {
        this.propertySearchService = propertySearchService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchPropertiesSectionalTitle($event) {
        const sectionalTitle = this.propertiesSectionalTitleForm.get(this.propertiesSectionalTitleFormControl).value;
        const unitNumber = this.propertiesSectionalTitleForm.get(this.propertiesUnitNumberFormControl).value;
        if (sectionalTitle !== "" || unitNumber !== "") {
            // @ts-ignore
            this.propertySearchCallback(this.propertySearchService.searchBySectionalTitle(sectionalTitle, unitNumber));
        }
        else {
            this.appController.showMessage(`${SharedConstants.NO_OPTION_SELECTED}`, AlertType.Warning);
        }
    }
    setUpForm() {
        this.propertiesSectionalTitleForm = new FormGroup({
            propertiesSectionalTitleFormControl: new FormControl(""),
            propertiesUnitNumberFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: PropertySearchService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        advancedSearchOccurred: [{ type: Output }]
    };
};
PropertiesSearchSectionalTitleComponent = __decorate([
    Component({
        selector: "app-properties-search-sectional-title",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PropertiesSearchSectionalTitleComponent);
export { PropertiesSearchSectionalTitleComponent };
